<template>
  <div class="app-wrapper" >
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <app-main />
    </div>
    <!-- <footer-menu class="sidebar-container" /> -->
  </div>
</template>

<script>
import { AppMain, Sidebar, FooterMenu } from "./components";

export default {
  name: "Layout",
  components: {
    AppMain,
    Sidebar,
    FooterMenu,
  },

  methods: {},
};
</script>
<style scoped>
.app-wrapper {
  max-width: 1920px;
  width: 1920px;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/layout/index.vue